import React, { Component, ReactNode } from 'react'

import Error from 'next/error'

import ErrorBoundaryMessage from './ErrorBondaryMessage'

interface Props {
  children?: ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
  }

  componentDidUpdate(): void {
    if (this.state.hasError) document.body.style.overflow = 'hidden'
  }

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  public render() {
    return (
      <>
        {this.state.hasError && (
          <>
            <div className='absolute z-50 top-0 let-0 w-full h-screen bg-[#11111133]'></div>
            <ErrorBoundaryMessage error={this.state.error} />
          </>
        )}
        {this.props.children}
      </>
    )
  }
}

export default ErrorBoundary
